import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customFields: [],
};

const customFieldsSlice = createSlice({
  name: "customFields",
  initialState,
  reducers: {
    setCustomFields(state, action) {
      state.customFields = action.payload;
    },
    addCustomField(state, action) {
      const newCustomField = action.payload;
      return {
        ...state,
        customFields: [...state.customFields, newCustomField],
      };
    },
    editCustomField(state, action) {
      const { id, customFieldDetails } = action.payload;
      const updatedCustomFields = state.customFields.map((customField) => {
        if (customField.id === id) {
          return customFieldDetails;
        }
        return customField;
      });
      return {
        ...state,
        customFields: updatedCustomFields,
      };
    },
    removeCustomField(state, action) {
      const idToRemove = action.payload;
      const newCustomFields = state.customFields.filter(
        (field) => field.id !== idToRemove
      );
      return {
        ...state,
        customFields: newCustomFields,
      };
    },
  },
});

export function getCustomFields() {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customField`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(customFieldsSlice.actions.setCustomFields(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function createCustomField({ data }) {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customField`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(customFieldsSlice.actions.addCustomField(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function updateCustomField({ id, data }) {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customField/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        customFieldsSlice.actions.editCustomField({
          id: id,
          customFieldDetails: response.data.data,
        })
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export function deleteCustomField({ id }) {
  return async (dispatch) => {
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/customField/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(customFieldsSlice.actions.removeCustomField(id));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default customFieldsSlice.reducer;
